import imageUrl from '../medias/8308c4e584a1453d2a29c1ca06a87a35.jpeg';
import videoUrl from '../medias/3fb8adf127945a8e5d99fcbd25be6057.mp4';

const mockResponse = {
    "data": [
        {
            "id": 2,
            "type": "campaign",
            "createdAt": "2025-03-04T08:05:47.987+09:00",
            "updatedAt": "2025-05-27T08:01:09.849+09:00",
            "name": "mobile",
            "isPublished": true,
            "isMobile": true,
            "insertElementKind": "id",
            "insertElementValue": "top__fullcarousel",
            "insertElementIndex": 1,
            "position": "outer_after",
            "topMargin": 0,
            "rightMargin": 0,
            "bottomMargin": 0,
            "leftMargin": 0,
            "topPadding": 0,
            "rightPadding": 0,
            "bottomPadding": 0,
            "leftPadding": 0,
            "frame": "circle",
            "originalPreviewUrl": null,
            "previewUrl": null,
            "contentGroups": [
                {
                    "id": "633",
                    "type": "contentGroup",
                    "createdAt": "2025-07-09T22:02:28.737+09:00",
                    "updatedAt": "2025-07-18T00:09:05.579+09:00",
                    "name": "mobileGroup",
                    "attachmentData": null,
                    "position": 1,
                    "imageUrl": null,
                    "contents": [
                        {
                            "id": "692",
                            "type": "content",
                            "createdAt": "2025-07-09T22:02:37.475+09:00",
                            "updatedAt": "2025-07-09T22:02:37.475+09:00",
                            "position": 1,
                            "ctaLink": "",
                            "ctaText": "",
                            "contentGroupId": 633,
                            "mediaAsset": {
                                "id": "312",
                                "type": "mediaAsset",
                                "createdAt": "2025-06-27T16:13:13.577+09:00",
                                "updatedAt": "2025-06-27T16:13:14.022+09:00",
                                "name": "resized20250627-1-l24gmk.jpg",
                                "attachmentData": {
                                    "id": "1e32e1f14b82ef45790a5093b8b26262.jpg",
                                    "storage": "store",
                                    "metadata": {
                                        "size": 62379,
                                        "width": 480,
                                        "height": 854,
                                        "filename": "resized20250627-1-t5uptr.jpg",
                                        "mime_type": "image/jpeg"
                                    }
                                },
                                "mediaUrl": imageUrl
                            }
                        },
                        {
                            "id": "693",
                            "type": "content",
                            "createdAt": "2025-07-09T22:02:37.475+09:00",
                            "updatedAt": "2025-07-09T22:02:37.475+09:00",
                            "position": 2,
                            "ctaLink": "",
                            "ctaText": "",
                            "contentGroupId": 633,
                            "mediaAsset": {
                                "id": "313",
                                "type": "mediaAsset",
                                "createdAt": "2025-06-27T16:13:13.577+09:00",
                                "updatedAt": "2025-06-27T16:13:14.022+09:00",
                                "name": "3fb8adf127945a8e5d99fcbd25be6057.mp4",
                                "attachmentData": {
                                    "id": "3fb8adf127945a8e5d99fcbd25be6057.mp4",
                                    "storage": "store",
                                    "metadata": {
                                        "size": 62379,
                                        "width": 480,
                                        "height": 854,
                                        "filename": "3fb8adf127945a8e5d99fcbd25be6057.mp4",
                                        "mime_type": "video/mp4"
                                    }
                                },
                                "mediaUrl": videoUrl
                            }
                        }
                    ]
                }
            ]
        }
    ],
    "meta": {
        "gtag": ""
    }
}

export default mockResponse;
